import React from "react";
import "./About.scss";
import { useState, useRef, useEffect } from "react";
import profile from "../../images/ver2.webp";

export default function About() {
  const about = useRef(null);

  const options = {
    root: null,
    threshold: 0.8,
    rootMargin: "-100px 0px 0px 0px",
  };

  const sectionOneObserver = new IntersectionObserver(function (
    entry,
    sectionOneObserver
  ) {
    if (!entry.isIntersecting) {
      const header = document.querySelector("header");
      header.classList.add("nav-scrolled");
    } else {
      const header = document.querySelector("header");
      header.classList.remove("nav-scrolled");
    }
  },
  options);

  useEffect(() => {
    if (about.current) {
      sectionOneObserver.observe(about.current);
    }

    return () => {
      if (about.current) sectionOneObserver.unobserve(about.current);
    };
  }, [about.current, options]);

  // clicker section. Should be moved to own component
  const clicker = useRef(null);
  const [insideText, setInsideText] = useState("Click the arrow");
  const [number, setNumber] = useState(0);
  const [brokenClicks, setBrokenClicks] = useState(0);

  // Array of strings to show up in the clicker box
  const stringsArray = [
    "Wow",
    "You're doing great!",
    "What a good clicker!",
    "Yea thats about it",
    "Its broken",
  ];

  const containerExpand = () => {
    let clickerContainer = document.querySelector(".clicker-container");
    clickerContainer.classList.add("expand");
    const removeExpand = setTimeout(() => {
      clickerContainer.classList.remove("expand");
    }, 500);
  };

  const stringAndMoveFunction = () => {
    let clickerMover = document.querySelector(".clicker-mover");
    stringsArray[number] && setInsideText(stringsArray[number]);
    setNumber(number + 1);
    if (number > 3) return;
    clickerMover.classList.toggle("move");
  };

  const blockClick = () => {
    clicker.current.disabled = true;
    const undisable = setTimeout(() => {
      clicker.current.disabled = false;
    }, 800);
  };

  const breakContainer = () => {
    let clickerContainer = document.querySelector(".clicker-container");
    setBrokenClicks(brokenClicks + 1);
    if (brokenClicks >= 4) {
      clickerContainer.classList.add("red");
      const removeExpand = setTimeout(() => {
        clickerContainer.classList.remove("red");
      }, 800);
      if (brokenClicks > 4) clickerContainer.classList.add("break");
    }
  };

  const handleClick = () => {
    containerExpand();
    stringAndMoveFunction();
    blockClick();
    breakContainer();
  };

  return (
    <section className="about" ref={about}>
      <div className="container">
        <figure className="image-container">
          <img
            // loading="lazy"
            src={profile}
            alt="its me. But actually a giraffe."
          />
        </figure>
        <div className="text-wrap">
          <h2 className="small-title">Welcome!</h2>
          <h1 className="title">My name is Nik&nbsp;Port</h1>
          <p className="text">
            I am a full-stack software engineer with more than four years of experience
            building everything from API's to UI's
          </p>
          <p class="text">
            I have a passion for implementing ideas and creating reliable,
            user-centered software experiences
          </p>
          <p class="text">
            Just look at this fun and interative experience, here:
          </p>

          <div className="clicker-container">
            <p className="inside-text">{insideText}</p>
            <div className="clicker-mover">
              <button
                ref={clicker}
                onClick={handleClick}
                className="clicker"
              ></button>
            </div>
          </div>
        </div>
      </div>
      <a className="downArrow" href="#whoIsNik">
        🠇
      </a>
    </section>
  );
}
